module.exports = __webpack_public_path__ + "img/logo-circulos.e8fa1d16.png";